export default function () {
    return (
        <svg width="288" height="82" viewBox="0 0 288 82" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M76.6181 60.8704H98.9038L81.0431 36.709L65.6704 46.0719L76.6181 60.8704Z" fill="white" />
            <path d="M168.226 50.183H176.226L186.814 10.6797H178.806L168.226 50.183Z" fill="white" />
            <path
                d="M145.06 10.6797H136.838L128.333 42.5273C127.199 46.7533 129.71 50.183 133.936 50.183H162.523L164.666 42.1981H136.646L145.06 10.6797Z"
                fill="white"
            />
            <path
                d="M222.987 38.6076L202.86 10.6797H202.677H194.454L183.867 50.183H192.089L199.576 22.2474L219.695 50.183H222.451H228.109L238.697 10.6797H230.467L222.987 38.6076Z"
                fill="white"
            />
            <path
                d="M287.908 10.6797H274.533L250.081 26.5576L254.337 10.6797H246.337L235.75 50.183H243.75L247.731 35.3233L262.651 50.183H276.026L256.703 30.9366L287.908 10.6797Z"
                fill="white"
            />
            <path d="M100.343 34.5348H122.445L124.642 26.3279H102.548L100.343 34.5348Z" fill="white" />
            <path d="M53.8963 0H31.6182L51.0788 26.3355L65.2878 15.4032L53.8963 0Z" fill="white" />
            <path d="M119.314 0H91.317L42.9025 37.1377H53.5057L0 82L91.6538 26.3279H80.9358L119.314 0Z" fill="url(#paint0_linear_540_1701)" />
            <defs>
                <linearGradient id="paint0_linear_540_1701" x1="112.715" y1="-5.23546e-07" x2="0.176075" y2="81.9158" gradientUnits="userSpaceOnUse">
                    <stop stopColor="#EAC64C" />
                    <stop offset="0.554786" stopColor="#C09325" />
                    <stop offset="1" stopColor="#AF7D14" />
                </linearGradient>
            </defs>
        </svg>
    );
}
